module.exports = __webpack_public_path__ + "static/media/terms.8f108c3a.pdf";